// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"a88650c5","160":"797b9c40","208":"40ea3799","293":"e88fad11","453":"ececc0a5","516":"e58194d1","519":"9a8239fb","713":"148e7b02","917":"4969be69","946":"5d460a92"}[chunkId] + ".chunk.js";
};